import { isInExtension } from '@mote/helpers'
import { getStorage } from '@mote/helpers/extension'
import { useGenericRequestHandler } from '../../handlers'

export const useCanInsertAudioIntoSlidesMutation = () => {
  const genericRequestHandler = useGenericRequestHandler({
    route: 'm/canInsertAudioIntoSlides',
    method: 'POST'
  })

  const original = genericRequestHandler.mutate

  /**
   * @param {Object|undefined} obj
   */
  async function decorated(obj) {
    let lastLoginHostname = ''
    if (isInExtension()) {
      lastLoginHostname =
        (await getStorage('lastLoginHostname')) || lastLoginHostname
    }

    const json = {
      containingURL: window.location.href,
      lastLoginHost: lastLoginHostname
    }
    return original({
      variables: obj ? { ...obj.variables, ...json } : json
    })
  }

  genericRequestHandler.mutate = decorated
  return genericRequestHandler
}
